import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Session-scoped global filter for Notification Groups list (SideNav bar).
 * Empty array per dimension = no filter (show all). AND across dimensions,
 * OR within a dimension — see `matchesStatusSelection` in GroupsData.
 */
export const GROUP_HEALTH_EMPTY = "empty";
export const GROUP_HEALTH_NO_RECIPIENTS = "no_recipients";
export const GROUP_HEALTH_NO_RESOURCES = "no_resources";
export const GROUP_HEALTH_ACTIVE = "active";

export type GroupHealthFilterId =
  | typeof GROUP_HEALTH_EMPTY
  | typeof GROUP_HEALTH_NO_RECIPIENTS
  | typeof GROUP_HEALTH_NO_RESOURCES
  | typeof GROUP_HEALTH_ACTIVE;

interface NotificationsGroupsFiltersState {
  /** Applied health/completeness filters. Empty = show all groups. */
  statusFilterSelection: GroupHealthFilterId[];
}

const initialState: NotificationsGroupsFiltersState = {
  statusFilterSelection: [],
};

const notificationsGroupsFiltersSlice = createSlice({
  name: "notificationsGroupsFilters",
  initialState,
  reducers: {
    setNotificationsGroupsStatusSelection: (
      state,
      action: PayloadAction<GroupHealthFilterId[]>
    ) => {
      state.statusFilterSelection = [...action.payload];
    },
    clearNotificationsGroupsFilters: (state) => {
      state.statusFilterSelection = [];
    },
  },
});

export const {
  setNotificationsGroupsStatusSelection,
  clearNotificationsGroupsFilters,
} = notificationsGroupsFiltersSlice.actions;

export default notificationsGroupsFiltersSlice.reducer;
